export const result = {
    "no_results_yet": "ຍັງບໍ່ໄດ້ຮັບຜົນທົດສອບເທື່ອ",
    "see_result": "ເບິ່ງຜົນ",
    "test_result": "ຜົນການທົດສອບ",
    "attempt": "ບົດທົດສອບ",
};

